import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import * as JsonAnimation from '../../../assets/lottie-animation/Logo.json';
export { JsonAnimation };

@Injectable({
  providedIn: 'root',
})
export class AnimationBuilderService {
  constructor() {}
  _coefficient = 0;

  public height: number = -1;
  public animation = JsonAnimation;

  public set windowCoefficient(value: number) {
    this._coefficient = value;
  }

  public animationOptions$: Subject<AnimationOptions<'svg'>> = new Subject();
  public refreshAndPlay$: Subject<AnimationOptions<'svg'>> = new Subject();

  /**
   * This updates animation and reloads the animation
   * with parameters.
   * @param height Height of animation, between 800 and 1200
   * @param offset The offset of page to set page
   * @param frame Number of animation frames
   */
  public updateAnimation(
    height: number,
    offset?: number,
    frame?: number
  ): void {}

  private getAnimationOptions(): AnimationOptions {
    return {
      loop: false,
      autoplay: false,
      renderer: 'svg',

      rendererSettings: {
        progressiveLoad: false,
        preserveAspectRatio: 'xMidYMid slice',
      },
      animationData: this.animation,
    };
  }
}
